import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const programBoardParentSwitcherEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-program-board-parent-switcher" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
